export const UPLOAD_MAX_ATTEMPS = 2;
export const MB_VALUE = 1048576
export const MAX_FILE_COMMENTS_IN_MB = 100
export const MAX_FILE_COMMENTS_IN_BYTES = MAX_FILE_COMMENTS_IN_MB * MB_VALUE
export const GB_TO_BYTE = 1073741824;
